import { redirectInNewTab } from 'utils/urlUtils';

export type IntegrationAccess =
  | { status: 'available'; accessUrl: string }
  | { status: 'accountPending' }
  | { status: 'unavailable' };

export type FetchIntegrationAccess = () => Promise<IntegrationAccess>;

interface RedirectToIntegrationAccessUrlArgs {
  fetchAccessUrl: FetchIntegrationAccess;
  onAccessError: () => void;
  onAccessPending?: () => void;
}

export const redirectToIntegrationAccessUrl = ({
  fetchAccessUrl,
  onAccessError,
  onAccessPending,
}: RedirectToIntegrationAccessUrlArgs) => {
  const access = fetchAccessUrl();

  return redirectInNewTab({
    getUrl: async () => {
      const result = await access;
      return result.status === 'available' ? result.accessUrl : undefined;
    },
    onError: async () => {
      const result = await access;

      return result.status === 'accountPending' && onAccessPending
        ? onAccessPending()
        : onAccessError();
    },
  });
};
